<div class="input" [class.validate-error]="control?.errors && (markAsDirty || (control.dirty && control.touched))">
  <ng-content></ng-content>
  <div class="errors">
    <ng-template ngFor let-error [ngForOf]="errors">
      <ng-template [ngIf]="hasError(error) && ((control.dirty && control.touched) || markAsDirty)">
        <div [class.show-error]="control.dirty || markAsDirty" class="form-error">{{error.text}}</div>
      </ng-template>
    </ng-template>
  </div>
</div>
